// extracted by mini-css-extract-plugin
export default {"getOffer5":"GetOffer5_getOffer5__oskIt","header":"GetOffer5_header__524OZ","textarea":"GetOffer5_textarea__GFTeU"};